const $win = $(window);
const $doc = $(document);

if ($('.product-reviews').length) {
  function moveReviewsForm() {
    if ($('.new-review-form').length) {
      $('.new-review-form').insertAfter('.stamped-header-title')
      // clear the interval
      window.clearInterval(reviewsInterval)
    }
  }

  $win.on('load resize', function(){
    if ($win.width() < 1024) {
      $('.js-tab-reviews .product-reviews').appendTo('.js-accordion-reviews .accordion__content');
    } else {
      $('.js-accordion-reviews .product-reviews').appendTo('.js-tab-reviews')
    }
  })

  const reviewsInterval = window.setInterval(moveReviewsForm, 300);
}
